export const URL = "check-in/setting-authority";
export const URL_INFO = "info/setting-authority";
export const SET_INFO = "SET_SETTNG_AUTHORITY_INFO";






